import React from "react";
import { useMediaQuery } from "@mui/material";

function Section5() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  return (
    <section>
      <div
        style={{
          height: "85vh",
          backgroundColor: "#6E07F3",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: isSmallScreen ? "80%" : "60%", // Adjusted width for smaller screens
            flexDirection: "column",
            paddingBottom: isSmallScreen ? "5rem" : "10rem", // Adjusted padding for smaller screens
          }}
        >
          <h1
            style={{
              color: "white",
              fontFamily: "Font1",
              fontSize: isSmallScreen ? "28px" : "32px", // Adjusted font size for smaller screens
              fontWeight: 800,
              marginBottom: "10px",
              letterSpacing: "1px",
              textShadow: "0px 0.1px, 0.1px 0px, 0.1px 0.1px",
            }}
          >
            My Work Experience
          </h1>
          <h2
            style={{
              color: "white",
              fontFamily: "Font2",
              textAlign: "center",
              fontSize: isSmallScreen ? "16px" : "20px", // Adjusted font size for smaller screens
              fontWeight: 500,
              lineHeight: 1.5,
              letterSpacing: "1px",
              textShadow: "0px 0.1px, 0.1px 0px, 0.1px 0.1px",
            }}
          >
            Venturing into the vibrant startup ecosystem during my college
            years, I’ve had the privilege of contributing to various roles and
            working with cutting-edge technologies. This hands-on experience has
            sharpened my skills and ignited a passion for the tech industry,
            fueling my desire to create impactful digital solutions.
          </h2>
        </div>
      </div>
    </section>
  );
}

export default Section5;
